<template>
  <div id="hit-default" v-bind:style="{'background-color': survey.badge.bg, 'border-color': survey.badge.accent}">

    <div class="hit-banderole-container"><a class="hit-banderole hit-html-a" href="https://hitklick.com" target="_blank" v-bind:style="{'color': survey.badge.pluscolor, 'background-color': survey.badge.accent}"><b>hitklick</b>.com</a></div>

    <div class="hit-title" v-bind:style="{color: survey.badge.text}">{{ survey.name }}</div>
    <div class="hit-top-stars" v-if="survey.all" v-bind:style="{color: survey.badge.text}">{{ survey.all_percent }} von 5 Sternen</div>
    <div class="hit-top-stars" v-if="!survey.all" v-bind:style="{color: survey.badge.text}">{{ $tc("message.noEntry", survey.all) }}</div>
    <div class="hit-stars"><hit_stars :stars="survey.all_percent" v-bind:style="{'color': survey.badge.accent}" /></div>

    <div class="hit-proz-container" v-for="star in stars" v-bind:key="star">
      <div class="hit-proz-stars" v-bind:style="{color: survey.badge.text}">{{ star }} {{ $tc("message.star", star) }}</div>
      <div class="hit-proz-bg" v-bind:style="{'background-color': survey.badge.pluscolor}"><div class="hit-proz-fg" v-bind:style="Object.assign(get_width(star), {'background-color': survey.badge.accent})"></div></div>
      <div class="hit-proz-avg" v-bind:style="{color: survey.badge.text}">{{ survey.votes[star] }}</div>
    </div>

    <div class="hit-votes" v-bind:style="{color: survey.badge.text}"><i class="hit-glyphicon hit-glyphicon-user"></i> {{ survey.all }} {{ $tc("message.feedback", survey.all) }}</div>
    <div class="hit-validated" v-if="survey.all" v-bind:style="{color: survey.badge.text}">{{ $t("message.validation") }}: 100%</div>

  </div>
</template>

<script>

export default{

  name: 'default',
  props: { survey: Object },

  data: function () {
    return {
      stars: [5, 4, 3, 2, 1]
    }
  },
  computed: {

    stars_reverse: function () {
      var rev = JSON.parse(JSON.stringify(this.stars))

      return rev.reverse()
    }

  },
  methods: {

    get_width: function (star) {
      if (!this.survey.percent[star]) { return {} }

      const width = (this.survey.percent[star] / 100) * 150

      return {width: width + 'px'}
    },

    get_avg_star_class: function (key) {
      if (Number.isInteger(this.survey.all_percent) == false && (key - this.survey.all_percent) < 1 && key > this.survey.all_percent) { return {'hit-glyphicon-star-half': true} } else if (key <= this.survey.all_percent) { return {'hit-glyphicon-star': true} } else { return {'hit-glyphicon-star-empty': true} }
    }
  }

}

</script>

<style scoped>

#hit-default{
  text-align: center;
  width: 250px;
  height: 330px;
  border: 1px solid darkgrey;
  font-family: Arial;
  font-size: 12pt;
  overflow: hidden;
  box-shadow: 0px 10px 20px -10px black;
  display: inline-block;

}

#hit-default .hit-banderole-container{
  text-align: left;
  position: absolute;

  padding-top: 15px;

  overflow: hidden;
  height: 70px;

}

#hit-default .hit-banderole{
  margin-left: -21px;
  font-size: 8pt;
  background-color: darkgrey;
  position: relative;
  padding: 3px 10px;
  color: white;
  transform: rotate(-45deg);
  width: 100px;
  text-align: center;
  display: inline-block;

}

#hit-default .hit-title{
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 0 40px;
  font-size: 12px;
  line-height: 0.9em;
}

#hit-default .hit-top-stars{
  font-size: 16pt;
  font-weight: bold;
}

#hit-default .hit-stars{
  margin-bottom: 20px;
  font-size: 18pt;
}

#hit-default .hit-proz-stars{
  float:left;
  width: 65px;

}

#hit-default .hit-proz-stars, #hit-default .hit-proz-avg{
  font-size: 10pt;
  padding-top: 2px;
}

#hit-default .hit-proz-avg{
  font-weight: bold;
  text-align: right;
  padding-right: 7px;

  font-size: 8pt;
}

#hit-default .hit-proz-bg{
  background-color: lightgrey;
  width: 150px;
  height: 18px;
  float:left;
}

#hit-default .hit-proz-fg{
  background-color: darkgrey;
  height: 18px;
  float:left;
}

#hit-default .hit-votes{
  margin-top: 10px;
}

#hit-default .hit-validated{
  font-size: 10px;
  margin-top: 10px;
}

#hit-default .hit-proz-container{
  margin-bottom: 8px;
  clear: both;
  float: none;
}
</style>
